export enum MassiveLoaderAuthorizations {
  CaricatoreMassivoEx = 'CARICATORE.MASSIVO.EXECUTE',
}

export const MassiveLoaderExecute = [MassiveLoaderAuthorizations.CaricatoreMassivoEx];

export const MassiveLoaderAuthorizationsList = [...MassiveLoaderExecute];
